var map = {
	"./AdiCupQ2022.ttf": 13712,
	"./Atlanta-College.ttf": 75810,
	"./Beyond.ttf": 31940,
	"./BlaugranaPersonalUse-Yq3pO.ttf": 89324,
	"./Brexon-Italic.ttf": 99978,
	"./Brexon-Regular.ttf": 46610,
	"./Bullet Rain.otf": 62422,
	"./BungeeShade-Regular.ttf": 50123,
	"./ELITAS-Bold.otf": 33108
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6092;